export default {
      id: "icon-navigate-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-navigate",
      toString: function () {
        return this.url;
      }
    }